/* eslint-disable max-len */

import { getApiUrl, JOB_API_URL } from '../../util/api/api'
import type { JobPostingProduct } from '../../../state/reducers/entitlement/entitlement'

const getPayload = (product, upgrades) => {
  const payload = {} as any
  if (product) { payload.jobPosting = product }
  if (upgrades?.length) { payload.jobUpgrades = upgrades }
  return payload
}

const submitDraft = async (id: string, product?: JobPostingProduct, upgrades?: Array<any>): Promise<any> => {
  const fetchResponse = await fetch(
    getApiUrl(`${JOB_API_URL}/${id}/submit`), {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      mode: 'cors',
      credentials: 'include',
      body: JSON.stringify(getPayload(product, upgrades)),
    }
  )

  if (fetchResponse?.ok) {
    const responseData = await fetchResponse.text()
    return Promise.resolve({ status: fetchResponse.status, data: responseData})
  } else {
    return Promise.reject(fetchResponse ? { status: fetchResponse.status, data: fetchResponse.statusText } : null)
  }
}
  
export default submitDraft
